<template>
  <div class="col-md-3 col-sm-12">
    <div id="dl-menu" class="dl-menuwrapper">
      <button class="dl-trigger"></button>
      <button class="dl-trigger2"></button>
      <ul class="dl-menu">
        <li>
          <a href="#">Wine Deals <i class="fa fa-angle-right"></i></a>
          <ul class="dl-submenu">
            <li v-for="item in menudeals" :key="item.id">
              <a href="#" @click.prevent="selectDeals(item.id)">{{ item.name }}</a>
            </li>
          </ul>
        </li>
        <li>
          <a href="#">Bottle Wine <i class="fa fa-angle-right"></i></a>
          <ul class="dl-submenu">
            <li v-for="item in menubottles" :key="item.id">
              <a href="#" @click.prevent="selectBottles(item.id)">{{ item.name }} <i class="fa fa-angle-right"></i></a>
              <ul class="dl-submenu">
                <li v-if="(item.countries.length>0)">
                  <a href="#">Location <i class="fa fa-angle-right"></i></a>
                  <ul class="dl-submenu">
                    <li v-for="country in item.countries" :key="country.id">
                      <a href="#" @click.prevent="selectCountry(country.id)"> {{ country.name }} <i v-if="(country.regions.length>0 && country.regions[0].name!=='All')" class="fa fa-angle-right"></i></a>
                      <ul class="dl-submenu" v-if="(country.regions.length>0 && country.regions[0].name!=='All')">
                        <li v-for="reg in country.regions" :key="reg.id">
                          <a href="#" @click.prevent="selectRegion(reg.id)">{{ reg.name }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li v-if="(item.sorts.length>0)">
                  <a href="#">Grape Varietal <i class="fa fa-angle-right"></i></a>
                  <ul class="dl-submenu">
                    <li v-for="grape in item.sorts" :key="grape.id">
                      <a href="#" @click.prevent="selectGrape(grape.id)"> {{ grape.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>		
        <li>
          <a href="#">Half + Magnum <i class="fa fa-angle-right"></i></a>
          <ul class="dl-submenu">
            <li>
              <a href="#">Half <i class="fa fa-angle-right"></i></a>
              <ul class="dl-submenu">
                <li v-for="item in menuhalfs" :key="item.id">
                  <a href="#" @click.prevent="selectHalf(item.id)">{{ item.name }}</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">Magnum <i class="fa fa-angle-right"></i></a>
              <ul class="dl-submenu">
                <li v-for="item in menumagnums" :key="item.id">
                  <a href="#" @click.prevent="selectMagnum(item.id)">{{ item.name }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <a href="#">By The Glass <i class="fa fa-angle-right"></i></a>
          <ul class="dl-submenu">
            <li v-for="item in menuglass" :key="item.id">
              <a href="#" @click.prevent="selectGlass(item.id)">{{ item.name }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainMenu',
  props: [
        'menudeals',
        'menubottles',
        'menuhalfs',
        'menumagnums',
        'menuglass'
        ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
        selectDeals (id) {
              bus.$emit('app:menu:deals', id)
            },
            selectBottles (id) {
              bus.$emit('app:menu:bottles',id)
            },
            selectHalf (id) {
              bus.$emit('app:menu:half',id)
            },
            selectMagnum (id) {
              bus.$emit('app:menu:magnum',id)
            },
            selectGlass (id) {
              bus.$emit('app:menu:glass',id)
            },
            selectGrape (id) {
              bus.$emit('app:menu:grape',id)
            },
            selectCountry (id) {
              bus.$emit('app:menu:country',id)
            },
            selectRegion (id) {
              bus.$emit('app:menu:region',id)
            }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/MainMenu.vue